import LogRocket from 'logrocket'
import SentryClient from '@/packages/sentry'

class Logger {
	constructor () {
		this.isProduction = process.env.NODE_ENV === 'production'
	}

	captureException (err, extra = {}) {
		if (this.isProduction) {
			LogRocket.captureException(err, { extra })
		}
		this.error(err)
	}

	captureMessage (msg, extra = {}) {
		if (this.isProduction) {
			LogRocket.captureMessage(msg, { extra })
		} else {
			console.debug(msg, extra)
		}
	}

	error (err) {
		if (this.isProduction) {
			LogRocket.error(err)
		} else {
			console.error(err)
		}
	}

	log (msg) {
		if (this.isProduction) {
			LogRocket.log(msg)
		} else {
			console.log(msg)
		}
	}

	info (msg) {
		this.log(msg)
	}

	setUser (user) {
		if (this.isProduction) {
			// Set user in LogRocket
			if (user) {
				LogRocket.identify(user.id, {
					name: user.name,
					email: user.email
				})
			}
		}

		// Set user in Sentry (works in all environments including development)
		if (user) {
			SentryClient.Sentry.setUser({
				id: user.id,
				email: user.email,
				username: user.username || user.name || `${user.firstname} ${user.lastname}`
			})
		} else {
			SentryClient.Sentry.setUser(null)
		}
	}
}

export default new Logger()
